export function parseDesignationCsv(content) {
    let jsonObj = []
    let storeIds;
    const rows = content.split("\n");

    if (rows.length > 1) {
        const headers = rows[0].split(',')

        for (let i = 1; i < rows.length; i++) {
            let data = rows[i].split(',');
            let obj = {}
            for (let j = 0; j < data.length; j++) {
                obj[headers[j].trim()] = data[j].trim();
            }
            jsonObj.push(obj)
        }
        storeIds = jsonObj.map(x => x.storeId).join(',');

    } else {
        storeIds = rows[0];
    }
    return storeIds;
}
